import { useQuery } from '@tanstack/react-query';
import { getDashboard, type DashboardData } from '../api/dashboard';

export function useDashboard(enabled: boolean) {
  return useQuery<DashboardData>({
    queryKey: ['dashboard'],
    queryFn: getDashboard,
    enabled,
    staleTime: 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000,
  });
}
